import { styled } from '@mui/material';

import { ToggleButtonGroup } from '@/components/Form/ToggleGroup';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectOperationUser } from '@/redux/operation';

export const enum TabEnum {
  Adult = 'adult',
  Minor = 'minor',
}

const tabs = [
  {
    value: TabEnum.Minor,
    text: 'common.' + TabEnum.Minor,
  },
  {
    value: TabEnum.Adult,
    text: `common.${TabEnum.Adult}`,
  },
];

type AdultChildToggleProps = {
  value: TabEnum;
  onChange: (newValue: TabEnum) => void;
};

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  maxWidth: 360,
  width: '100%',

  backgroundColor: theme.palette.grey[200],
  borderRadius: 32,
  padding: theme.spacing(0.5),

  '.MuiToggleButton-root': {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 32,
    color: theme.palette.grey[700],
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    textTransform: 'none',
    fontSize: theme.typography.body2Medium.fontSize,
    fontWeight: theme.typography.body2Medium.fontWeight,
    lineHeight: theme.typography.body2Medium.lineHeight,
    transition: theme.transitions.create(['background-color', 'color']),

    ':hover': {
      backgroundColor: 'transparent',
    },
    '&.MuiToggleButtonGroup-grouped': {
      height: 32,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.primary,
      outline: 'none',
      ':hover': {
        backgroundColor: theme.palette.common.white,
      },
    },
  },
}));

export const AdultChildToggle = ({
  value,
  onChange,
}: AdultChildToggleProps) => {
  const { t } = useTranslate();
  const operationUser = useAppSelector(selectOperationUser);

  const handleTabChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: TabEnum | null,
  ) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <StyledToggleButtonGroup
      disabled={!operationUser?.infoAccuracyConfirmed}
      fullWidth
      size="medium"
      options={tabs.map(tab => ({
        ...tab,
        text: t(tab.text),
      }))}
      onChange={handleTabChange}
      value={value}
    />
  );
};
